import { gql } from 'apollo-angular';

/**
 * Order schema
 */
export class OrderSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		uid
		externalUid
		orderComment
		orderNumber
		orderDate
		returnDate
		purchaser {
			uid
			name
			billingAddress {
				address1
				address2
				zipCode
				city
				region {
					name
				}
				country {
					name
				}
			}
			phoneNumber
		}
		contractor {
			uid
			name
			billingAddress {
				address1
				address2
				zipCode
				city
				region {
					name
				}
				country {
					name
				}
			}
			phoneNumber
		}
		state
		patient {
			firstName
			lastName
			gender
			dateOfBirth
		}
		restorations {
			uid
			type
			restorationElements {
				uid
				type
				toothNumber
			}
		}
		insurance
		`;

	/**
	 * Get orders
	 */
	static readonly getOrderList = gql`
		query GetOrderList(
				$filters: [WhereFilter],
				$pageIndex: Int!,
				$resultsPerPage: Int!,
				$orderBy: String,
				$isAscending: String) {
			orderlist(
			filters: $filters,
			pageIndex: $pageIndex,
			resultsPerPage: $resultsPerPage,
			orderBy: $orderBy,
			isAscending: $isAscending) {
				totalCount
				list {
					${OrderSchema.topLevelProperties}
				}
			}
		}
	`;

	static readonly updateOrderState = gql`
		mutation UpdateOrderState($input: OrderStates!, $comment: String = null, $externalOrderUid: ID = null) {
			updateOrderState(input: $input, comment: $comment, externalOrderUid: $externalOrderUid) {
				${OrderSchema.topLevelProperties}
			}
		}
	`;
}
